import { useMemo } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import MicrosoftAdsProduct from 'components/search/MicrosoftAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';

const MicrosoftAdsWrapper = ({
  msftResults,
  msaImageParams,
  trackMicrosoftAdImpressions,
  makeMicrosoftAdClick,
  numMicrosoftAds,
  msftAdsToShow,
  CardBottomSlot
}) => {
  const {
    marketplace: {
      search: { hasStyleRoomFlag }
    }
  } = useMartyContext();

  const products = useMemo(
    () =>
      msftResults.results?.map((product, i) => ({
        ...product,
        index: i,
        isSponsored: true
      })),
    [msftResults.results]
  );

  if (!msftAdsToShow) {
    return null;
  }

  return msftResults.results.map((_props, i) => {
    const product = products[i];
    const { styleId, colorId } = product;
    product.isLowStock = getLowStockLabelStatus({
      ...product,
      hasStyleRoomFlag
    });

    return (
      styleId &&
      colorId && (
        <MicrosoftAdsProduct
          key={`${styleId}-${colorId}`}
          product={product}
          numMicrosoftAds={numMicrosoftAds}
          trackMicrosoftAdImpressions={trackMicrosoftAdImpressions}
          makeMicrosoftAdClick={makeMicrosoftAdClick}
          msaImageParams={msaImageParams}
          CardBottomSlot={CardBottomSlot}
        />
      )
    );
  });
};

export default MicrosoftAdsWrapper;
